import { useState, useEffect, useRef, useCallback } from "react";
import CommentModal from "../../Models/CommentBoxModel/CommentBox";
import EmojiPicker from "emoji-picker-react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import {
  TimelineInsert,
  CompanyTimeline,
  TimelineGet,
  TimelineLike,
  DeletePost,
} from "../../apis/api/TimelineApi";
import { useDispatch, useSelector } from "react-redux";
import LazyLoad from "react-lazy-load";
import Lodderr from "../../components/Lodder/Lodder";

const AllTimeline = () => {
  const dispatch = useDispatch();
  const [commentPost, setcommentPost] = useState();
  const [postToDelete, setPostToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [text, setText] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const photoInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const musicInputRef = useRef(null);
  const [preview, setPreview] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [page, setPage] = useState(0);
  const [last_Id, setlast_Id] = useState(0);
  const [Loading, setLoading] = useState(false);
  const [allLoaded, setAllLoaded] = useState(false);
  const throttleRef = useRef(null);
  const fetchingRef = useRef(false);
  const [posts, setPosts] = useState([]);

  const userId = Cookies.get("userID");
  const company_id = Cookies.get("company_id");
  const access = JSON.parse(Cookies.get("access"));
  const user = JSON.parse(Cookies.get("user"));
  console.log(user,"user")

  const { loading } = useSelector((state) => state.TimelineSlice);

  const fetchPosts = useCallback(async () => {
    if (Loading || allLoaded || fetchingRef.current) return;

    fetchingRef.current = true;
    setLoading(true);

    try {
      await new Promise((resolve) => setTimeout(resolve, 500));

      const response = await dispatch(
        CompanyTimeline({ userId, company_id, page, last_Id })
      );

      if (response.payload.status === "success") {
        const newPosts = response.payload.data;

        if (newPosts.length > 0) {
          setPosts((prevPosts) => [...prevPosts, ...newPosts]);
          setPage((prevPage) => prevPage + 1);
          setlast_Id(response.payload.lastCompanyPostId);
        }

        if (last_Id === 1) {
          setAllLoaded(true);
          startThrottle();
        }
      } else {
        setAllLoaded(true);
        startThrottle();
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
      fetchingRef.current = false;
      setLoading(false);
    }
  }, [page, Loading, allLoaded]);

  const startThrottle = () => {
    console.log("throttleRefstart");
    if (!throttleRef.current) {
      throttleRef.current = setTimeout(() => {
        console.log("throttleRef");

        throttleRef.current = null;
      }, 5 * 60 * 1000);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !Loading && !allLoaded) {
          fetchPosts();
        }
      },
      { threshold: 1.0 }
    );

    const target = document.getElementById("loadMoreTrigger");
    if (target) observer.observe(target);

    return () => observer.disconnect();
  }, [fetchPosts, Loading, allLoaded]);

  useEffect(() => {
    fetchPosts();
  }, []);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      event.target.value = null;
      setSelectedFile(file);
      setPreview(URL.createObjectURL(file));

      if (file.type.startsWith("image")) {
        setFileType("image");
      } else if (file.type.startsWith("video")) {
        setFileType("video");
      } else if (file.type.startsWith("audio")) {
        setFileType("audio");
      }
    }
  };
  const handlePost = async () => {
    if (selectedFile || text) {
      const data = new FormData();
      data.append("file", selectedFile);
      data.append("text", text);
      data.append("userId", userId);
      data.append("company_id", company_id);
      data.append("post_access", access.post_access);
      data.append("post_per_weak", access.post_per_weak);
      data.append("post_total_limit", access.post_total_limit);
      data.append("post_unlimited_access", access.post_unlimited_access);

      const response = await dispatch(TimelineInsert(data));
      if (response.payload.status == "success") {
        
        const newPost = await dispatch( CompanyTimeline({ userId, company_id, page:0, last_Id:0 }));
        let newpostdone = newPost?.payload?.data;
        setPosts(newpostdone)
      

        setPreview(null);
        setText("");
        toast.success("Post Uploaded Successful");
      } else if (response.payload.status == "error") {
        setPreview(null);
        setText("");
        toast.error(response.payload.msz);
      } else {
        setPreview(null);
        setText(null);
        toast.error("ERROR");
      }
    } else {
      toast.error("Your post is empty. Please add something to share.");
    }
  };
  const handleFileSelect = (inputRef, type) => {
    if (inputRef.current) {
      setFileType(type);
      inputRef.current.click();
    }
  };

  const handleEmojiClick = (emojiData) => {
    setText((prev) => prev + emojiData.emoji);
  };

  const handleLike = async (
    company_post_id,
    post_like,
    company_like,
    liked
  ) => {
    let new_like_count = liked ? Number(post_like) - 1 : Number(post_like) + 1;
    let new_like_status = liked ? 0 : 1;

    let new_company_like;

    if (company_like === null || company_like === "") {
      new_company_like = userId;
    } else {
      if (liked == 0) {
        new_company_like = company_like?.split(",").filter(Boolean).map(Number);
        new_company_like.push(userId);
        new_company_like = new_company_like.join();
      } else {
        new_company_like = company_like?.split(",").filter(Boolean).map(Number);
        new_company_like = new_company_like.filter(
          (element) => element != userId
        );
        new_company_like = new_company_like.join();
      }
    }

    console.log(posts);
    const response = await dispatch(
      TimelineLike({ company_post_id, new_like_count, new_company_like })
    );
    if (response.payload.status === "success") {
      setPosts((prevPosts) =>
        prevPosts.map((post) =>
          post?.company_post_id == company_post_id
            ? {
                ...post,
                post_like: new_like_count,
                liked: new_like_status,
                company_like: new_company_like,
              }
            : post
        )
      );
    } else {
      toast.error("Failed to update like status");
    }
  };

  const setcomment = (data) => {
    setcommentPost(data);
    console.log(data, "commenrt data ");
    setShowCommentModal(true);
  };
  const handleDelete = async (post) => {
   
    const response = await dispatch(
      DeletePost({ postid: post?.company_post_id })
    );
    if (response?.payload?.status == "success") {
      const newPost = await dispatch(CompanyTimeline({ userId, company_id, page:0, last_Id:0 }));
      const updatedPosts = newPost?.payload?.data;
      setPosts(updatedPosts);
      toast.success("Post deleted Succesfully..");
    } else {
      toast.error("error in deleting post..");
    }
  };

  return (
    <>
      {loading && <Lodderr />}
      <CommentModal
        show={showCommentModal}
        data={commentPost}
        handleClose={() => setShowCommentModal(false)}
      />
      {(access.post_access && access.post_access === "1") && 
      <div class="row d-flex justify-content-evenly">
        <div className="col-12 ">
          <div className="card p-3 shadow-sm">
            <div className="d-flex align-items-center mb-2">


              <textarea
                className="form-control"
                placeholder="What's on your mind? fhdhf"
                rows="3"
                value={text}
                onChange={(e) => setText(e.target.value)}
              ></textarea>
            </div>
            {preview && (
              <div className="mt-2 position-relative d-flex justify-content-center">
                {/* Close Button */}
                <button
                  className="btn btn-sm btn-danger position-absolute"
                  style={{ top: "-10px", right: "-10px", zIndex: 10 }}
                  onClick={() => setPreview(null)}
                >
                  &times;
                </button>

                {fileType === "image" && (
                  <img
                    src={preview}
                    alt="Preview"
                    className="border rounded"
                    style={{
                      width: "300px",
                      height: "300px",
                      objectFit: "cover",
                    }}
                  />
                )}
                {fileType === "video" && (
                  <video
                    src={preview}
                    controls
                    className="border rounded"
                    style={{
                      width: "300px",
                      height: "300px",
                      objectFit: "cover",
                    }}
                  ></video>
                )}
                {fileType === "audio" && (
                  <audio
                    src={preview}
                    controls
                    className="border rounded"
                    style={{ width: "300px" }}
                  ></audio>
                )}
              </div>
            )}

            {showEmojiPicker && (
              <div className="position-relative bg-white shadow p-2 rounded emoji-picker-container">
                <EmojiPicker onEmojiClick={handleEmojiClick} />
              </div>
            )}

            <div className="d-flex align-items-center justify-content-between mt-2 flex-wrap">
              <div className="d-flex gap-2">
                <button
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => handleFileSelect(photoInputRef, "image")}
                >
                  <i className="bx bx-image"></i> Photo
                </button>
                <button
                  className="btn btn-outline-success btn-sm"
                  onClick={() => handleFileSelect(videoInputRef, "video")}
                >
                  <i className="bx bx-video"></i> Video
                </button>
                <button
                  className="btn btn-outline-info btn-sm"
                  onClick={() => handleFileSelect(musicInputRef, "audio")}
                >
                  <i className="bx bx-music"></i> Music
                </button>
              </div>

              <div>
                <button
                  className="btn btn-primary btn-sm me-3"
                  onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                >
                  <i className="bx bx-smile"></i>
                </button>
                <button className="btn btn-primary btn-sm" onClick={handlePost}>
                  <i className="bx bx-send"></i> Post
                </button>
              </div>
              <input
                type="file"
                accept="image/*"
                ref={photoInputRef}
                className="d-none"
                onChange={handleFileChange}
              />
              <input
                type="file"
                accept="video/*"
                ref={videoInputRef}
                className="d-none"
                onChange={handleFileChange}
              />
              <input
                type="file"
                accept="audio/*"
                ref={musicInputRef}
                className="d-none"
                onChange={handleFileChange}
              />
            </div>
          </div>

          {posts.map((post, index) => (
            <div
              key={index}
              className="card mt-2 p-3 shadow-sm position-relative"
            >
              <div className="d-flex justify-content-between align-items-start">
                <div className="d-flex align-items-center ">
                  <img
                    src={
                      post?.member_logo
                        ? post.member_logo
                        : 
                    `${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`
                    }
                    className="rounded-circle me-2"
                    alt="User"
                    style={{
                      width: "40px",
                      height: "40px",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        "/gray-avatar-icon-vector-illustration_276184-163.avif";
                    }}
                  />

                  <div>
                    <h6 className="mb-0">{post?.member_name}</h6>
                    <p className="text-muted small mb-0">
                      {post?.company_name}
                    </p>
                  </div>
                </div>
                {userId == post?.member_id &&
                  company_id == post?.company_id && (
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => {
                        setPostToDelete(post);
                        setShowDeleteModal(true);
                      }}
                    >
                      <i className="bx bx-trash"></i> Delete
                    </button>
                  )}

                {/* User Info */}
              </div>

              {/* Post Text or Blob Preview */}
              {post?.text?.startsWith("blob:") ? (
                post?.text.includes("video") ? (
                  <video src={post?.text} controls className="w-100"></video>
                ) : (
                  <img src={post?.text} alt="Post Preview" className="w-100" />
                )
              ) : post?.text ? (
                <p className="mt-2">{post.text}</p>
              ) : null}

              {/* Media File (image, video, audio) */}
              {post?.file_extension &&
                post?.file_url &&
                (post.file_extension === "image" ? (
                  <LazyLoad>
                    <img
                      src={post.file_url}
                      className="w-100"
                      style={{ height: "600px", objectFit: "cover" }}
                      alt="Post Image"
                    />
                  </LazyLoad>
                ) : post.file_extension === "video" ? (
                  <video src={post.file_url} controls className="w-100"></video>
                ) : post.file_extension === "audio" ? (
                  <div
                    className="d-flex align-items-center justify-content-center bg-light"
                    style={{
                      height: "100px",
                      borderRadius: "5px",
                      fontSize: "1.2rem",
                    }}
                  >
                    <audio src={post.file_url} controls />
                  </div>
                ) : null)}

              {/* Like and Comment Buttons */}
              <div className="d-flex mt-3 align-items-center gap-3">
                <button
                  className={`btn btn-sm ${
                    post?.liked ? "btn-danger" : "btn-outline-danger"
                  } d-flex align-items-center gap-2`}
                  onClick={() =>
                    handleLike(
                      post?.company_post_id,
                      post?.post_like,
                      post?.company_like,
                      post?.liked
                    )
                  }
                >
                  <i
                    className={`bx ${post?.liked ? "bxs-heart" : "bx-heart"}`}
                  ></i>
                  {post?.post_like} Like
                </button>

                <button
                  className="btn btn-sm btn-outline-primary d-flex align-items-center gap-2"
                  onClick={() => setcomment(post)}
                >
                  <i className="bx bx-comment"></i> Comment
                </button>
              </div>
            </div>
          ))}

          {showDeleteModal && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Confirm Delete</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowDeleteModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p>Are you sure you want to delete this post?</p>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowDeleteModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={() => {
                        handleDelete(postToDelete);
                        setShowDeleteModal(false);
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      }
      <div id="loadMoreTrigger"></div>
    </>
  );
};

export default AllTimeline;
